import type { InsightsMethodMap } from 'search-insights';
import insights from 'search-insights';
import type { User } from 'types/User';

let PRODUCT_INDEX = '';

export function init(data: {
  apiKey: string;
  appId: string;
  productIndex: string;
}) {
  PRODUCT_INDEX = data.productIndex;

  insights('init', {
    apiKey: data.apiKey,
    appId: data.appId
  });
}

function sendToAlgolia(eventName: keyof InsightsMethodMap, data: object) {
  if (!PRODUCT_INDEX) return;

  insights(eventName, data);
}

export function clickedObjectIdAfterSearch({
  id,
  queryID,
  position,
  user
}: {
  id: string;
  position: number;
  queryID: string;
  user: User;
}) {
  sendToAlgolia('clickedObjectIDsAfterSearch', {
    authenticatedUserToken: user.profile?.uid,
    eventName: 'Product Clicked',
    index: PRODUCT_INDEX,
    objectIDs: [id],
    positions: [position],
    queryID,
    userToken: user.guestId
  });
}

export function convertedObjectIdAfterSearch({
  id,
  queryID,
  user,
  eventName
}: {
  eventName: 'Save Product Clicked' | 'Notify Me Clicked';
  id?: string;
  queryID: string;
  user: User;
}) {
  sendToAlgolia('convertedObjectIDsAfterSearch', {
    authenticatedUserToken: user.profile?.uid,
    eventName,
    index: PRODUCT_INDEX,
    objectIDs: [id],
    queryID,
    userToken: user.guestId
  });
}

export function addedToCartObjectIDsAfterSearch({
  id,
  user,
  queryID
}: {
  id?: string;
  queryID: string;
  user: User;
}) {
  sendToAlgolia('addedToCartObjectIDsAfterSearch', {
    authenticatedUserToken: user.profile?.uid,
    eventName: 'Buy now Clicked',
    index: PRODUCT_INDEX,
    objectIDs: [id],
    queryID,
    userToken: user.guestId
  });
}

export function purchasedObjectIDsAfterSearch({
  id,
  price,
  queryID,
  user
}: {
  id: string;
  price: string;
  queryID?: string | null;
  user: User;
}) {
  sendToAlgolia('purchasedObjectIDsAfterSearch', {
    authenticatedUserToken: user.profile?.uid,
    currency: 'GBP',
    eventName: 'Sole Marketplace Purchase',
    index: PRODUCT_INDEX,
    ...(queryID
      ? {
          objectData: [
            {
              price,
              quantity: 1,
              queryID
            }
          ]
        }
      : {}),
    objectIDs: [id.toString()],
    userToken: user.guestId
  });
}

export default {
  addedToCartObjectIDsAfterSearch,
  clickedObjectIdAfterSearch,
  convertedObjectIdAfterSearch,
  init,
  purchasedObjectIDsAfterSearch
};
